module.exports = "https://static.zego.com/_next/static/images/hero-generic-682af77a25142387274ca5367485085d.jpg";